import type { UserRole } from '../types.ts';

export function dashboardPathFor(role: UserRole): string {
  if (role === 'EXTRA') return '/extra';
  if (role === 'ORG_OWNER' || role === 'ORG_MANAGER') return '/resto';
  if (role === 'APPORTEUR') return '/apporteur';
  return '/admin';
}
